export default __webpack_public_path__ + "static/media/horizontal_ray.d1ed62b3.svg";